module.exports = __webpack_public_path__ + "img/b-0.11cac52e.png";